export const yourLoansSelector = ({ entities }) => ({
  accounts: entities.accounts,
});
